export default function AboutSection() {
  return (
    <section id="over-ons" className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20in%20matching%20uniforms%20with%20eco-friendly%20cleaning%20supplies%2C%20bright%20modern%20office%20interior%2C%20soft%20natural%20daylight%2C%20smiling%20friendly%20confident%20team%20portrait%2C%20warm%20pink%20magenta%20accent%20tones%20in%20environment%2C%20clean%20minimalist%20composition%2C%20professional%20commercial%20photography%2C%20shallow%20depth%20of%20field%2C%20fresh%20spotless%20atmosphere&width=800&height=600&seq=az-schoonmaak-team&orientation=portrait"
                alt="A&Z Schoonmaakdienst team"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
              Over A&Z Schoonmaakdienst
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Een team met passie voor{' '}
              <span className="text-primary-500">schoonmaak</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-5">
              A&Z Schoonmaakdienst is opgericht vanuit een gedeelde passie voor schoonmaak en hygiëne. 
              Wij geloven dat elk bedrijf — van een klein kantoor tot een groot winkelpand — een frisse en schone werkomgeving verdient.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Ons team bestaat uit ervaren en betrouwbare schoonmaakprofessionals die weten hoe belangrijk grondigheid, 
              discretie en een professionele uitstraling zijn. Wij werken uitsluitend met milieuvriendelijke schoonmaakmiddelen 
              en moderne apparatuur voor het beste resultaat.
            </p>

            <div className="grid grid-cols-3 gap-6">
              {[
                { value: '500+', label: 'Tevreden klanten' },
                { value: '40+', label: 'Schoonmakers' },
                { value: '24/7', label: 'Beschikbaar' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}